import React from "react";
import "./RoomRules.css";

import {
  FaSignInAlt,
  FaSignOutAlt,
  FaRegCalendarTimes,
  FaChild,
  FaBaby,
  FaBed,
  FaBan,
  FaInfoCircle,
  FaCcMastercard,
  FaCcAmazonPay,
  FaCcVisa ,
  FaPaypal,
  FaCreditCard,
  FaMoneyBillWave,
  FaUniversity,
} from "react-icons/fa";




  const paymentIcons = {
  "Visa Card": <FaCcVisa />,
  "Master Card": <FaCcMastercard />,
  "Union Pay": <FaCcAmazonPay />,
  "Credit & Debit Cards": <FaCreditCard />,
  "PayPal": <FaPaypal />,
  "Payoneer": <FaCreditCard />, // خاص icon available نہیں
  "Cash": <FaMoneyBillWave />,
  "Bank": <FaUniversity />,
};



const HouseRules = ({ property }) => {
function formatTimeToAMPM(timeStr) {
  if (!timeStr) return "";

  const [hoursStr, minutesStr] = timeStr.split(":");
  let hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10) || 0;
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 → 12

  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

  return `${hours}:${formattedMinutes} ${ampm}`;
}
  
  return (
    <div className="container">
      <h2>
        House rules of {property?.propertyName || "Hotel Details"}
      </h2>
      {/* <p className="HouseRules_note">
        Ramada by Wyndham Karachi Creek takes special requests – add in the next step!
      </p> */}

      {/* Check-in */}
      <div className="HouseRules_section">
      <h3 className="HouseRules_h3"><FaSignInAlt /> Check-in</h3>
      <p>
        From {formatTimeToAMPM(property?.checkIn?.from)} to{" "}
        {formatTimeToAMPM(property?.checkIn?.until)}
      </p>
      <p className="HouseRules_text">
        Guests are required to show a photo ID and credit card at check-in.<br />
        You need to let the property know what time you'll be arriving in advance.
      </p>
    </div>

    {/* Check-out */}
    <div className="HouseRules_section">
      <h3 className="HouseRules_h3"><FaSignOutAlt /> Check-out</h3>
      <p>
        From {formatTimeToAMPM(property?.checkOut?.from)} to{" "}
        {formatTimeToAMPM(property?.checkOut?.until)}
      </p>
    </div>

      {/* Cancellation */}
      <div className="HouseRules_section">
        <h3 className="HouseRules_h3"><FaRegCalendarTimes /> Cancellation/ prepayment</h3>
        <p>{property?.rules.cancellationPolicy}
          {/* Cancellation and prepayment policies vary according to accommodation type. 
          <a href="#"> Check what conditions</a> apply to each option when making your selection. */}
        </p>
      </div>

      {/* Children & Beds */}
      <div className="HouseRules_section">
        <h3 className="HouseRules_h3"><FaChild /> Children & Beds</h3>
        <h4>Child policies</h4>
        <p> Children of {property?.rooms[0].childPolicy} ages are welcome.</p>
        <p>Children above {property?.rooms[0].childPolicy} will be charged as adults at this property.</p>
        <p className="HouseRules_text">To see correct prices and occupancy info, add the number and ages of children in your group to your search.</p>

        {/* <h4>Crib and extra bed policies</h4>
        <div className="HouseRules_box">
          <p><strong>0 - 3 years</strong></p>
          <p><FaBed /> Extra bed upon request — US$10 per child, per night</p>
          <p><FaBaby /> Crib upon request — US$10 per child, per night</p>
        </div>

        <div className="HouseRules_box">
          <p><strong>4+ years</strong></p>
          <p><FaBed /> Extra bed upon request — US$10 per person, per night</p>
        </div>
    <br />
        <p className="HouseRules_text">
          Prices for cribs and extra beds aren&apos;t included in the total price. They&apos;ll have to be paid for separately during your stay.<br />
          The number of extra beds and cribs allowed depends on the option you choose. Check your selected option for more info.<br />
          All cribs and extra beds are subject to availability.
        </p> */}
      </div>

      {/* Age restriction */}
      <div className="HouseRules_section">
        <h3 className="HouseRules_h3"><FaChild /> Age restriction</h3>
        <p>The minimum age for check-in is {property?.rules.ageRestriction}</p>
      </div>

      {/* Pets */}
      <div className="HouseRules_section">
        <h3 className="HouseRules_h3"><FaBan /> Pets</h3>
        <p>Pets are {property?.rules.pets}.</p>
      </div>

      {/* Cards */}
      <div className="HouseRules_section">
        <h3 className="HouseRules_h3"><FaCreditCard /> Cards accepted at this hotel</h3>
<ul className="HouseRules_ul flex flex-row flex-wrap items-center gap-4">
  {property.acceptedPaymentMethods?.map((method, index) => (
    <li key={index} className="flex items-center gap-2">
      {paymentIcons[method] ?? <FaCreditCard />} {method}
    </li>
  ))}
</ul>




       
        {!property.acceptedPaymentMethods?.includes("Cash") && (
        <p className="HouseRules_text text-red">Cash is not accepted</p>
        )}
      </div>

      {/* Fine Print */}
        <h2 ><FaInfoCircle /> The Fine Print</h2>
        <div className="HouseRules_section">
        <p className="HouseRules_note">Must-know information for guests at this property</p>
        <ul className="HouseRules_ul">
        <li>Please note that all adults must produce their CNIC card or passport upon check-in.</li>
        <li>Food from outside is not allowed at the property.</li>
        <li>Airport Pick & Drop via Hotel Car PKR 2500/- + tax per side.</li>
        <li>Guests are required to show a photo ID and credit card upon check-in. All Special Requests are subject to availability and additional charges may apply.</li>
        <li>Please inform {property?.propertyName || "Hotel Details"} of your expected arrival time in advance. You can use the Special Requests box when booking, or contact the property directly using the contact details in your confirmation.</li>
        </ul>
        </div>

    </div>
  );
};

export default HouseRules;

